export default "__VITE_ASSET__NZQ7TBOQ__"